import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fullscreen-wrapper dialog-wrapper"
}
const _hoisted_2 = { class: "dialog" }
const _hoisted_3 = { class: "dialog__title" }
const _hoisted_4 = { class: "dialog__text" }
const _hoisted_5 = { class: "dialog__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withCtx(() => [
        (_ctx.visible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.text), 1),
                (_ctx.takeInput)
                  ? (_openBlock(), _createBlock(_component_TextInput, {
                      key: 0,
                      id: "input",
                      modelValue: _ctx.input,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input) = $event)),
                      class: "mb",
                      icon: "sticky-note",
                      placeholder: _ctx.t('dialogs.inputPlaceholder'),
                      required: "",
                      type: "text"
                    }, null, 8, ["modelValue", "placeholder"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "dialog__button button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submit(true)))
                  }, _toDisplayString(_ctx.t('common.confirm')), 1),
                  _createElementVNode("button", {
                    class: "dialog__button button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit(false)))
                  }, _toDisplayString(_ctx.t('common.cancel')), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}